const setData = (state, action) => {
  Object.entries(action.payload).forEach(([key, value]) => {
    state[key] = value
  })
  // Ownership is derived from the catalogue whenever one arrives, rather than being a second field
  // the server also sends. The wallet fills `ownedCosmetics` at bootstrap and the shop's answers
  // carry `owned` on every card; letting the two live side by side is how the reaction tray ends
  // up not offering something that was bought a second ago.
  if (Array.isArray(action.payload.cosmetics)) {
    state.ownedCosmetics = action.payload.cosmetics.filter((item) => item.owned).map((item) => item.id)
  }
  return state
}

// The balance alone, for the places that learn it as a side effect of something else — buying a
// class answers with the new balance, and so does `/users/me/`. Merging the whole payload there
// would blank the shop catalogue that is not in it.
const setCredits = (state, action) => {
  state.credits = action.payload.credits
  return state
}

const reducers = {
  setData,
  setCredits,
}

export default reducers
